<template>
  <div class="page-content wrapper">
    <div class="content" v-for="bigCourse in bigCourseList" :key="bigCourse.class_id">
        <div class="title">{{bigCourse.subject }} -- {{ bigCourse.title }}</div>
        <el-table
            border
            stripe
            :data="bigCourse.chapter_list"
            :empty-text="$t('common.EmptyData')">
            <el-table-column
                prop="chapter_title"
                :label="$t('course.SubclassTitle')"
                align="center"
                width="280">
                <template slot-scope="scope">
                    <ct-button class="chapter-title" @click="goSubCourseDetail(bigCourse)">{{scope.row.chapter_title}}</ct-button>
                </template>
            </el-table-column>
            <el-table-column
                v-for="workItem in bigCourse.workList"
                :key="workItem.work_id"
                :label="workItem.workLabel | workTypeLabel($t)"
                align="center"
                minWidth="90">
                    <el-table-column
                        :prop="workItem.work_type + 'author'"
                        :label="$t('course.QuestionSetter')"
                        align="center"
                        minWidth="90">
                    </el-table-column>
                    <el-table-column
                        :prop="workItem.work_type+'score'"
                        :label="$t('course.Score')"
                        align="center"
                        minWidth="90">
                    </el-table-column>
                    <el-table-column
                        :prop="workItem.work_type+'percent'"
                        :label="$t('course.Percent')"
                        align="center"
                        minWidth="90">
                    </el-table-column>
                    <el-table-column
                        :prop="workItem.work_type + 'avg'"
                        :label="$t('course.Avg')"
                        align="center"
                        minWidth="90">
                    </el-table-column>
                     <el-table-column
                        :label="$t('common.Detail')"
                        align="center"
                        minWidth="90">
                        <template slot-scope="scope">
                            <ct-button class="chapter-title" @click="goWorkDetail(scope.row, workItem, bigCourse)">
                              {{ $t('common.Detail') }}
                            </ct-button>
                        </template>
                    </el-table-column>
            </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui'
import 'element-ui/lib/theme-chalk/table.css'
import 'element-ui/lib/theme-chalk/table-column.css'
// import 'element-ui/lib/theme-chalk/select.css'
// import 'element-ui/lib/theme-chalk/option.css'
import api from '@/pages/comet/api'
export default {
  components: {
    'el-table': Table,
    'el-table-column': TableColumn
    // 'el-select': Select,
    // 'el-option': Option
  },
  data () {
    return {
      searchForm: {
        subject: ''
      },
      subjectList: [],
      tableData: [],
      bigCourseList: []
    }
  },
  methods: {
    // 数字转成百分比
    percent (val) {
      return (val * 100).toFixed(2) + '%'
    },
    goSubCourseDetail (bigCourse) {
      this.$router.push({
        name: 'liveCourseDetail',
        params: {
          origin: bigCourse.class_id
        }
      })
    },
    goWorkDetail (row, work, bigCourse) {
      this.$router.push({
        name: 'answer',
        params: {
          exam_id: work.work_id,
          class_id: bigCourse.class_id,
          subclass_id: row.chapter_id
        }
      })
    }
  },
  filters: {
    workTypeLabel (val, $t) {
      if (+val === 1) {
        return $t('course.WorkTypeEpParts')
      } else if (+val === 2) {
        return $t('course.WorkTypeExItems')
      } else if (+val === 3) {
        return $t('course.WorkTypeCmkItems')
      }
    }
  },
  mounted () {
    api.statistics({}).then(res => {
      if (res.data.code === 1) {
        this.bigCourseList = (res.data.data.list || []).map(item => {
          let workList = []
          item.chapter_list = item.chapter_list.map(chapItem => {
            const obj = {}
            chapItem.work_list.map(workItem => {
              obj[workItem.work_type + 'author'] = workItem.author
              obj[workItem.work_type + 'avg'] = workItem.avg
              obj[workItem.work_type + 'score'] = workItem.mark
              obj[workItem.work_type + 'percent'] = !workItem.mark ? this.percent(0) : this.percent(workItem.mark / workItem.total)
            })
            chapItem.work_list.map(workItem => {
              if (!workList.some(someItem => someItem.work_type === workItem.work_type)) {
                workList.push({
                  ...workItem,
                  workLabel: workItem.work_type
                })
              }
            })
            return { ...chapItem, ...obj }
          })
          return {
            workList: workList,
            ...item
          }
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.page-content {
    padding: 20px;
    .title {
        padding: 20px 0;
    }
}
.chapter-title {
    color: #37cad7;
    min-width: unset;
    padding: 12px 12px;
}
/deep/ .my-select {
    width: 200px;
    .ct-select-input {
        line-height: 48px;
        border: 1px solid rgba(26,61,94,.16);
        padding: 0 24px;
        &::placeholder {
          color: rgba(118,139,158,1);
          font-size: 14px;
        }
    }
}

</style>
